module.exports = require('./' + process.env.WEBPACK_ENV);
